import React, { FC, memo } from 'react';

interface TeamSizeFormatProps {
  size?: number;
}

const TeamSizeFormatComponent: FC<TeamSizeFormatProps> = ({ size }) => {
  if (!size) {
    return null;
  }

  return <>{`${size}v${size}`}</>;
};

export const TeamSizeFormat = memo(TeamSizeFormatComponent);
